import { render, staticRenderFns } from "./RedisMonitor.vue?vue&type=template&id=15ccedce&scoped=true&"
import script from "./RedisMonitor.vue?vue&type=script&lang=js&"
export * from "./RedisMonitor.vue?vue&type=script&lang=js&"
import style0 from "./RedisMonitor.vue?vue&type=style&index=0&id=15ccedce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ccedce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ccedce')) {
      api.createRecord('15ccedce', component.options)
    } else {
      api.reload('15ccedce', component.options)
    }
    module.hot.accept("./RedisMonitor.vue?vue&type=template&id=15ccedce&scoped=true&", function () {
      api.rerender('15ccedce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RedisMonitor.vue"
export default component.exports